import React from 'react';

const ImageJs = (props) => (
    <svg {...props} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <defs>
            <circle id="path-1" cx="28" cy="28" r="28"/>
        </defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-373.000000, -369.000000)">
                <g transform="translate(120.000000, 189.000000)">
                    <g transform="translate(54.000000, 180.000000)">
                        <g transform="translate(199.000000, 0.000000)">
                            <use fill="#0677B5" xlinkHref="#path-1"/>
                            <use className="image-filter" fillOpacity="0.1" fill="#000000" xlinkHref="#path-1"/>
                            <g transform="translate(14.451613, 14.451613)" fill="#FFFFFF">
                                <polygon id="Fill-3" points="0.341578453 27.0700924 6.14841215 27.0700924 6.14841215 8.79564516 0.341578453 8.79564516"/>
                                <path d="M3.24482451,6.31920138 C1.28074841,6.31920138 -0.000170789226,4.95288757 -0.000170789226,3.15960069 C-0.000170789226,1.36631381 1.28074841,-3.55271368e-15 3.24482451,-3.55271368e-15 C5.20890062,-3.55271368e-15 6.4044252,1.36631381 6.48981981,3.15960069 C6.57521443,4.86749295 5.29429523,6.31920138 3.24482451,6.31920138" id="Fill-5"/>
                                <path d="M27.0702632,26.9848686 L21.2634295,26.9848686 L21.2634295,17.2498827 C21.2634295,14.7734389 20.4094833,13.1509412 18.3600126,13.1509412 C16.736661,13.1509412 15.7981742,14.2610712 15.3712012,15.3703472 C15.2004119,15.7973203 15.2004119,16.3105419 15.2004119,16.8229096 L15.2004119,26.9848686 L9.39357824,26.9848686 C9.39357824,26.9848686 9.47811891,10.5037082 9.39357824,8.71042134 L15.2004119,8.71042134 L15.2004119,11.2722597 C15.9689635,9.99134053 17.3352773,8.28344827 20.4094833,8.28344827 C24.2522409,8.28344827 27.0702632,10.9306813 27.0702632,16.4813311 L27.0702632,26.9848686 Z" id="Fill-6"/>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ImageJs;



// WEBPACK FOOTER //
// ./src/components/SocialMedium/assets/Linkedin.js